module.exports = __webpack_public_path__ + "static/media/empty_cart.0ed99fb1.png";